import {axios} from './axios';
import {store} from '@/store';
import router  from '@/router';

/**
 * Initialize request interceptor
 */
export const initializeRequestInterceptors = () => {
    axios.interceptors.request.use(authInterceptor);
};

/** Auth token interceptor */
const authInterceptor = config => {
    config.headers.Authorization = `Bearer ${getToken()}`;
    return config;
};

/**
 * Initialize response interceptors
 *
 * @param vm
 */
export const initializeResponseInterceptors = vm => {
    axios.interceptors.response.use(
        interceptors.onSuccess.bind(vm),
        interceptors.onError.bind(vm)
    );
};

/**
 * Response interceptors
 */
const interceptors = {
    onSuccess(response) {
        const messages = [];
        if (response.headers['pos-app-version']) {
            store.dispatch('setVersion', parseFloat(response.headers['pos-app-version']));
        }

        if (response.data.success && !response.data.skip_notification) {
            messages.push(response.data.message);
            setTimeout(function () {
                store.dispatch('setSuccessMessages', messages);
            }, 200);
        }
        return response;
    },

    onError: function (error) {
        if (!error.response) {
            store.dispatch('setErrorMessages', ['Etwas ist schiefgelaufen.']);
            return Promise.reject(error);
        }

        if (error.response.headers['pos-app-version']) {
            store.dispatch('setVersion', parseFloat(error.response.headers['pos-app-version']));
        }

        if (error.response.status === 401) {
            window.localStorage.removeItem('ACCESS_TOKEN');
            window.localStorage.removeItem('USER_NAME');
            store.dispatch('setAuth', null);
            router.push({name: "login"});
        }

        if (error.response.status === 422 || error.response.status === 500) {
            const messages = [];

            if (typeof error.response.data.errors === 'string') {
                messages.push(error.response.data.errors)
            } else if (error.response.data.errors) {
                for (let key in error.response.data.errors) {
                    messages.push(error.response.data.errors[key]);
                }
            } else {
                messages.push(error.response.data.message)
            }
            store.dispatch('setErrorMessages', messages);
        }

        return Promise.reject(error);
    },
};

function getToken() {
    return localStorage.getItem('ACCESS_TOKEN')
}
